import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("uk_cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("uk_cart", JSON.stringify(items)); }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        product_id: product.id,
        name_tr: product.name_tr,
        name_en: product.name_en,
        price: product.discounted_price || product.price,
        image: product.images?.[0],
        quantity: qty,
      }];
    });
  };
  const removeItem = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const updateQty = (pid, qty) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
